import styled from 'styled-components'
import { CssUnit } from '@/types'
import { toUnit } from '@/utils/styles'

interface Props {
  gutter?: CssUnit
  width?: CssUnit
  minItemWidth?: CssUnit
  children: React.ReactNode
  repeat?: CssUnit
  className?: string
}

// 0px vs 0 in this context actually has
// a different meaning/result in the calc
const GridComponent = styled.div<{
  width: CssUnit
  repeat: CssUnit
  gutter: CssUnit
  minItemWidth: CssUnit
}>`
  --width: ${({ width }) => width};
  --repeat: ${({ repeat }) => repeat};
  --gutter: ${({ gutter }) => toUnit(gutter)};
  --minItemWidth: ${({ minItemWidth }) => (minItemWidth !== 0 ? toUnit(minItemWidth) : '0px')};

  > * {
    margin: 0;
  }

  display: grid;
  gap: var(--gutter);
  grid-template-columns: repeat(var(--repeat), minmax(min(var(--minItemWidth), 100%), 1fr));
  width: var(--width);
`

const Grid: React.FC<Props> = ({
  gutter = 0,
  minItemWidth = 0,
  width = 'auto',
  repeat = 'auto-fit',
  children,
  className
}) => {
  return (
    <GridComponent
      gutter={gutter}
      width={width}
      minItemWidth={minItemWidth}
      className={className}
      repeat={repeat}
    >
      {children}
    </GridComponent>
  )
}

export default Grid
